/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { isElementNull } from '../../../../utils';
import { EAssetDateRangeSelectionMode, IPolylineBalloon, IUserSettings } from '../../../core/models';
import { ReplayFormattingService } from '../../../replay/services';

@Component({
  selector: 'fm-polyline-hover-balloon',
  templateUrl: './polyline-hover-balloon.component.html',
  styleUrls: ['./polyline-hover-balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolylineHoverBalloonComponent implements OnChanges {
  @Input()
  balloon: IPolylineBalloon;
  @Input()
  userSettings: IUserSettings;

  formattedDate: string;
  relativeDateFormatted: string;

  EAssetDateRangeSelectionMode = EAssetDateRangeSelectionMode;

  constructor(private readonly _replayFormattingService: ReplayFormattingService) {}

  ngOnChanges(_: SimpleChanges): void {
    if (!isElementNull(this.balloon) && !isElementNull(this.userSettings)) {
      this.formattedDate = this._replayFormattingService.polylineBalloonDate(moment(this.balloon.date), this.userSettings);
      this.relativeDateFormatted =
        this.balloon.selectionMode === EAssetDateRangeSelectionMode.Previous7Days
          ? ReplayFormattingService.relativeDaysAgo(moment(this.balloon.date), this.userSettings)
          : ReplayFormattingService.dayXOfY(this.balloon.day, this.balloon.totalDays);
    }
  }
}
